import { API_URL } from '../../../app-config/constants';
import type {
    ChatHistoryItem,
    CoachPromptType,
    ContextReference,
    MiniCoach,
    SetupStatus,
} from '../../react/features/AiCoach/types';
import { get, post } from '../request';

const BASE_URL = `${API_URL}/copilot`;

aiCoachPrompt.operation = 'COMMAND';
export function aiCoachPrompt(
    type: CoachPromptType,
    input: string,
    assistantId: string,
    id?: string,
    contextReference?: ContextReference
) {
    return post<ChatHistoryItem>(BASE_URL, { postData: { id, type, input, assistantId, contextReference } });
}

getCoaches.operation = 'READ';
export function getCoaches() {
    return get<MiniCoach[]>(`${BASE_URL}/assistants`);
}

export function getSetupStatus() {
    return get<SetupStatus>(`${BASE_URL}/setup-status`);
}
